import React from 'react';
import { cn } from '@/lib/utils';

type Props = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

function Section({ title, children, className }: Props) {
  return (
    <div className={cn(className)}>
      <h6 className="text-base font-semibold mb-3">{title}</h6>
      <div className="grid gap-3">{children}</div>
    </div>
  );
}

export default Section;
